









































import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { CustomerUrlModel } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "ParticaWebsiteForm",
		components: { ButtonList }
	})
export default class ParticaWebsiteForm extends ParticaBaseForm<CustomerUrlModel> {

	private urlconfig =
		{
			props: { name: "url", placeholder: "Enter url", label: "Domain", disabled: true, } as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

	private secureconfig =
		{
			props: {
				name: "secure", placeholder: "Choose secure", label: "Website Security", required: true, disabled: true,
				values: [
					{ label: "Not Secure", value: "free" } as EnumDTO,
					{ label: "Secure", value: "register" } as EnumDTO,
					{ label: "Secure with Expiry date check", value: "secure" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private searchEngineIndexedconfig =
		{
			props: {
				name: "searchEngineIndexed",
				placeholder: "Enter searchEngineIndexed",
				label: "SEO",
				disabled: true
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;
	private securityTypeconfig =
		{
			props: {
				name: "securityType",
				placeholder: "Choose securityType",
				label: "Security Type",
				required: true,
				disabled: true,
				values: [
					{ label: "Unknown", value: "unknown" } as EnumDTO,
					{ label: "NoSecurity", value: "noSecurity" } as EnumDTO,
					{ label: "CompulsoryRegistration", value: "compulsoryRegistration" } as EnumDTO,
					{ label: "Subscription", value: "subscription" } as EnumDTO,
					{ label: "TokenIntegration", value: "tokenIntegration" } as EnumDTO,
					{ label: "CRM", value: "crm" } as EnumDTO,
					{ label: "CustomAPI", value: "customAPI" } as EnumDTO
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

}
